module.exports = __webpack_public_path__ + "img/home-what-is.a9e8ae7.webp";